const dentalCharts = [
    {
        value: "fdi",
        text: "FDI",
        chart: {
            kid: [
                { label: 'Top left', class: 'align-items-end', items: [55, 54, 53, 52, 51] },
                { label: 'Top right', class: 'align-items-end', items: [61, 62, 63, 64, 65] },
                { label: 'Bottom left', class: 'align-items-start', items: [85, 84, 83, 82, 81] },
                { label: 'Bottom right', class: 'align-items-start', items: [71, 72, 73, 74, 75] },
            ],
            adult: [
                { label: 'Top left', class: 'align-items-end', items: [18, 17, 16, 15, 14, 13, 12, 11] },
                { label: 'Top right', class: 'align-items-end', items: [21, 22, 23, 24, 25, 26, 27, 28] },
                { label: 'Bottom left', class: 'align-items-start', items: [48, 47, 46, 45, 44, 43, 42, 41] },
                { label: 'Bottom right', class: 'align-items-start', items: [31, 32, 33, 34, 35, 36, 37, 38] },
            ]
        }
    },
    {
        value: "usa",
        text: "USA",
        chart: {
            kid: [
                { label: 'Top left', class: 'align-items-end', items: ['A', 'B', 'C', 'D', 'E'] },
                { label: 'Top right', class: 'align-items-end', items: ['F', 'G', 'H', 'I', 'J'] },
                { label: 'Bottom left', class: 'align-items-start', items: ['T', 'S', 'R', 'Q', 'P'] },
                { label: 'Bottom right', class: 'align-items-start', items: ['O', 'N', 'M', 'L', 'K'] },
            ],
            adult: [
                { label: 'Top left', class: 'align-items-end', items: [1, 2, 3, 4, 5, 6, 7, 8] },
                { label: 'Top right', class: 'align-items-end', items: [9, 10, 11, 12, 13, 14, 15, 16] },
                { label: 'Bottom left', class: 'align-items-start', items: [32, 31, 30, 29, 28, 27, 26, 25] },
                { label: 'Bottom right', class: 'align-items-start', items: [24, 23, 22, 21, 20, 19, 18, 17] },
            ]
        }
    },
];
export default dentalCharts;
